export default __webpack_public_path__ + "static/media/MediumSBExcessiveMovementEdited.6d5fc7d4.png";